const notificationPhrases = {
  DEFAULT: 'made changes',
  'add.operationSequence': 'added __ITEMS__',
  'add-edit.operationSequence': 'added and edited __ITEMS__',
  'add-delete.operationSequence': 'added and deleted __ITEMS__',
  'delete-edit.operationSequence': 'changed and deleted __ITEMS__',
  'delete.operationSequence': 'deleted __ITEMS__',
  'restore.operationSequence': 'restored __ITEMS__',
  'edit.operationSequence': 'edited __ITEMS__',
  'style.operationSequence': 'changed styles on __ITEMS__',
  'position.operationSequence': 'moved __ITEMS__',
  'mixed.operationSequence': 'changed __ITEMS__',
  'change.operationSequence': 'changed __ITEMS__',
  'collapse-expand.operationSequence': 'collapsed/expanded __ITEMS__',
  'comment-change.operationSequence': 'modified __ITEMS__',
  'comment-resolve.operationSequence': 'resolved __ITEMS__',
  'comment-unresolve.operationSequence': 'reopened __ITEMS__',

  addBatch: 'added __ITEMS__',
  addNode: 'added __ITEMS__',
  setMapTitle: "changed the map's title",
  'function.paste': "pasted a selection",
  updateMapShareSettings: "updated the map's share settings",
  editNode: 'edited __ITEMS__',
  deleteNodes: 'deleted __ITEMS__',
  undeleteNodes: 'restored __ITEMS__ from trash',
  'deleteNodes.bulk': 'deleted __ITEMS__',
  'setCollapsedState': 'collapsed/expanded a card',
  'setNodeLayoutName': "changed layout of __ITEMS__",
  'bulk.setNodeLayoutName': "changed layout of __ITEMS__",
  'updateNodePositions.moveNode': 'moved __ITEMS__',
  'updateNodePositions.bulk.moveNode': 'moved __ITEMS__',
  'updateNodePositions.bulk.reorder': 'reordered __ITEMS__',
  'bulk.updateNodePositions': 'moved __ITEMS__',
  'addFileToNode': 'added a file to __ITEMS__',
  'rotateNodeFile': 'rotated image on __ITEMS__',
  'deleteNodeFile': 'removed a file attachment from __ITEMS__',
  'undeleteNodeFile': 'restored a file attachment on __ITEMS__',
  'updateNodeFile': 'updated a file attachment on __ITEMS__',
  'function.addPart': 'added a part to __ITEMS__',
  'updateNodePositions.adoption': 'moved a part into a card',
  'updateNodePositions.emancipationadoption': 'moved a part into a card',
  'updateNodePositions.emancipation': 'moved a part out of a card',
  'updateNodePositions.reorder': 'reordered parts of a card',
  setChildrenPosition: 'moved a pop-out',
  setChildrenDetached: 'toggled a card pop-out',
  'updateNodePositions.bulk.emancipation': 'moved __ITEMS__ out of a card',
  'updateNodePositions.bulk.adoption': 'moved __ITEMS__ into a card',
  'bulk.setChildrenDetached': 'toggled several card pop-outs',
  'function.createSystemFromSelection': 'grouped several parts into a new card',
  'updateNodePositions.bulk.emancipationadoption': 'moved several parts to another card',
  addLink: 'added __ITEMS__',
  setLinkAngles: 'moved __ITEMS__',
  'bulk.setLinkAngles': 'moved __ITEMS__',
  setLinkColor: "changed style of __ITEMS__",
  deleteLink: 'deleted __ITEMS__',
  setLinkDirection: "changed arrows on __ITEMS__",
  'bulk.setLinkDirection': "changed arrows on __ITEMS__",
  setLinkEndpoints: "moved a relationship to another card",
  undeleteLink: "restored a deleted relationship",
  setLinkWidth: "changed a relationship's thickness",
  setLinkType: "changed a relationship's style",
  setLinkNodeId: "added a card to a relationship",
  'bulk.setLinkColor': 'changed style of __ITEMS__',
  'bulk.setLinkType': 'changed style of __ITEMS__',
  'bulk.setLinkWidth': 'changed style of __ITEMS__',
  addToPerspectiveView: 'added __ITEMS__ to a perspective view',
  setNodePerspectiveOverride: 'edited a perspective note',
  addPerspectivePoint: 'added a perspective point',
  'addPerspectivePoint.addToPerspectiveView': 'added __ITEMS__ and created a new perspective',
  deleteFromPerspectiveView: 'removed __ITEMS__ from a perspective view',
  deletePerspectivePoint: 'deleted a perspective point',
  undeleteFromPerspectiveView: 'restored __ITEMS__ to a perspective view',
  editPerspectivesOrderCollection: 'reordered perspectives',
  updateMapDisplayProperties: "changed a map's settings",
  'updateMapDisplayProperties.annotationStyle': 'changed perspective style',
  updatePerspectiveNodeViews: 'edited a perspective note',
 'updatePerspectiveNodeViews.annotationTitle': 'edited a perspective note',
 'updatePerspectiveNodeViews.annotationPosition': 'moved a perspective note',
 'undeletePerspectivePoint': 'restored a perspective point',

  'setNodeDisplayStyle': 'changed style of __ITEMS__',
  'bulk.setNodeDisplayStyle': 'changed style of __ITEMS__',
  'setNodeBackgroundColor': 'changed style of __ITEMS__',
  'bulk.setNodeBackgroundColor': 'changed style of __ITEMS__',
  'setNodeDisplayStyle.setNodeBackgroundColor': 'changed style of __ITEMS__',
  'setNodeBackgroundColor.setNodeDisplayStyle': 'changed style of __ITEMS__',

  updatePresentationWaypointOrderIndexes: 'reordered waypoints',
  updatePresentationWaypointTitle: "edited a waypoint's title",
  updatePresentationWaypointNodeIds: 'edited a waypoint',
  'bulk.removePresentationWaypoint': 'removed a waypoint',
  'bulk.addPresentationWaypoint': 'added __ITEMS__ to a waypoint',
  createPresentation: 'started a new waypoint presentation',
  addPresentationWaypoint: 'added a waypoint',
  removePresentationWaypoint: 'removed a waypoint',
  clearPresentationWaypoints: 'removed all waypoints',

  addMapNodeAttribute: 'added an attribute to __ITEMS__',
  editMapNodeAttribute: 'edited an attribute on __ITEMS__',
  removeMapNodeAttribute: 'removed an attribute from __ITEMS__',
  'bulk.addMapNodeAttribute': 'added an attribute to __ITEMS__',
  'bulk.editMapNodeAttribute': 'edited an attribute on __ITEMS__',
  'bulk.removeMapNodeAttribute': 'removed an attribute from __ITEMS__',

  addRegion: 'added __ITEMS__',
  updateRegion: 'updated __ITEMS__',
  deleteRegion: 'deleted __ITEMS__',
  undeleteRegion: 'restored __ITEMS__',
  'bulk.updateRegion': 'updated __ITEMS__',
  'bulk.deleteRegion': 'deleted __ITEMS__',
  'bulk.undeleteRegion': 'restored __ITEMS__',
  addComment: 'added a comment',
  editComment: 'edited a comment',
  deleteComment: 'deleted a comment',
  undeleteComment: 'restored a comment',
  resolveComment: 'resolved a comment',
  unresolveComment: 'reopened a comment',
}

module.exports = {
  notificationPhrases
};



// WEBPACK FOOTER //
// ./shared/lib/operation-phrases.js